export enum MenuTypes {
    SELECTED_MENU = 'SELECTED_MENU',
    SET_MENU_TO_INITIAL = 'SET_MENU_TO_INITIAL',
    SET_MENU_COLOR = 'SET_MENU_COLOR',
}

export interface MenuState {
    mainMenu: string
    subMenu: string
    currentLink: string
    colorDark: boolean
}

export interface SelectedMenu {
    mainMenu: string
    subMenu: string
    currentLink: string
}

export interface MenuColor {
    colorDark: boolean
}
